module.exports = __webpack_public_path__ + "img/20210118_163017.2ef940c7.jpg";